// This file was automatically generated from util.feed.html.
// Please don't edit this file by hand.

goog.provide('el8.template.util.feed');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.util.feed.failedImage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ImagePlaceHolderText"><p class="el8FeedEmpty">Sorry, the image could not be loaded.</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.util.feed.failedImageRotation = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="image-failed-rotation-text el8ImagePlaceHolderText"><p class="el8FeedEmpty">Sorry, this image failed to rotate. We will automatically re-generate it and try again.</p></div>');
  if (!opt_sb) return output.toString();
};
